<template>
    <div class="all_form_block" data-name="citizen">
        <div class="block">
            <div class="name_tools" id="cv-citizens">{{ $store.getters.cv_t('citizen') }}</div>
            <div class="all_form">
                <div class="inp_info">
                    <input type="hidden" name="citizens" v-model="$store.getters.cvCitizensIds">
                    <multiselect
                        v-model="value"
                        label="title"
                        track-by="id"
                        :placeholder="''"
                        :options="options"
                        :multiple="true"
                        :selectLabel="''"
                        :deselectLabel="''"
                        :taggable="false"
                        :showNoOptions="true"
                    >
                        <span slot="noResult">{{$store.getters.cv_t('no_elements')}}</span>
                        <span slot="noOptions">{{$store.getters.cv_t('select_empty')}}</span>

                    </multiselect>
                </div>
            </div>
        </div>
        <div class="edit_block_form inp_info">
            <div
                class="div_relative"
                v-for="(citizen, index) in $store.state.cv.cvCitizens"
                :key="index+key"
                v-if="citizen.title !== MIX_LINE_INTELLECT_BR"
            >
                <div class="close" @click="$store.state.cv.cvCitizens.splice(index, 1)"></div>
                <div class="change_priority">
                    <div  v-if="index !== 0" class="prev" @click="prev(index,'cvCitizens')"></div>
                    <div  v-if="index !== ($store.state.cv.cvCitizens.length - 1)" class="next" @click="next(index,'cvCitizens')"></div>
                </div>
                <div class="icon_inp clearfix">
                    <div class="div_relative width100">
                        <input type="text" :value="citizen.title" disabled>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Multiselect from "vue-multiselect";
    import VueSlider from "vue-slider-component";
    import tools from "../../../../mixins/tools";
    export default {
        mixins: [tools],
        components: {
            Multiselect,
            VueSlider
        },
        data() {
            return {
                value:this.$store.state.cv.cvCitizens,
                citizens: {},
                options: [],
                custom: [],
                selecteds:[]
            };
        },

        watch: {
            "$parent.citizens"(to, from) {
                this.createOptions(to);
            },
            '$store.state.cv.cvCitizens'(to, from) {
                this.value = to;
            },
            value(to, from) {
                if( to.length >= from.length){
                    this.selecteds = this.value;
                    this.$store.commit('cvCitizens', this.value)
                }
                //When clicked backspace
                else{
                    this.value = this.selecteds;
                }
            }
        },
        methods: {
            getCitizens() {
                this.$http({
                    method: "post",
                    url: "/api/cv/citizens"
                }).then(res => {
                    this.createOptions(res.data.citizens);
                });
            },
            createOptions(citizens) {
                var option = this.custom.slice();
                for (let citizen in citizens) {
                    let translations = citizens[citizen]["translations"];

                    for (let item in translations) {
                        if (this.$store.state.cv.cvCitizens) {
                            this.$store.state.cv.cvCitizens.forEach(elem => {
                                if (elem.id === citizens[citizen]["id"]) {
                                    elem.title = translations[item]["title"];
                                }
                            });
                        }

                        option.push({
                            title: translations[item]["title"].trim(),
                            id: citizens[citizen]["id"],
                            custom: citizens[citizen]["custom"]
                        });
                    }
                }
                this.options = option;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/cv/tools-components/Citizen.vue